import { render } from "./FactoryEditor.vue?vue&type=template&id=7633b74a&scoped=true&ts=true"
import script from "./FactoryEditor.vue?vue&type=script&lang=ts"
export * from "./FactoryEditor.vue?vue&type=script&lang=ts"

import "./FactoryEditor.vue?vue&type=style&index=0&id=7633b74a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7633b74a"]])

export default __exports__